import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when IS_BRANDED_PRESENTATIONS_ENABLED is set to "true" on the server.
// Reads from the public /app-config endpoint — no auth required.
export const useBrandedPresentationsEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.isBrandedPresentationsEnabled ?? false;
};
